/* assets/qpost-delivery.js — added 2026-06-16
 * QPost (Qatar Post) Onwani delivery enforcement.
 * - Persists delivery_Zone/Street/BuildingNo/UnitNo to cart attributes via /cart/update.js
 *   (so the values survive any checkout path and reach the order's note_attributes,
 *    which the kickersQPost Vercel bridge reads).
 * - Blocks the cart / cart-drawer "checkout" button until all 4 are filled,
 *   with Zone & Street required to be numeric (Qatar Onwani).
 * The fields also POST natively as name="attributes[...]"; this script is the
 * validation + UX + redundant-persistence layer. Event delegation on document so it
 * survives the theme's AJAX cart re-renders.
 */
(function () {
  if (window.__qpostDeliveryInit) return;
  window.__qpostDeliveryInit = true;

  var FIELDS = [
    { key: 'delivery_Zone',       label: 'Zone No.',        numeric: true  },
    { key: 'delivery_Street',     label: 'Street No.',      numeric: true  },
    { key: 'delivery_BuildingNo', label: 'Building No.',    numeric: false },
    { key: 'delivery_UnitNo',     label: 'Unit / Flat No.', numeric: false }
  ];
  var SAVE_DEBOUNCE = 450;
  var saveTimer = null;

  function fieldEls(key) { return document.querySelectorAll('[data-qpost-field="' + key + '"]'); }
  function hasFields()   { return !!document.querySelector('[data-qpost-field]'); }

  function validate() {
    for (var i = 0; i < FIELDS.length; i++) {
      var f = FIELDS[i];
      var els = fieldEls(f.key);
      if (!els.length) continue;
      var v = (els[0].value || '').trim();
      if (!v) return { valid: false, el: els[0], msg: 'Please enter your ' + f.label };
      if (f.numeric && !/^[0-9]{1,6}$/.test(v)) {
        return { valid: false, el: els[0], msg: f.label + ' must be a number (e.g. 25)' };
      }
    }
    return { valid: true };
  }

  function persist() {
    if (!hasFields()) return;
    var attrs = {};
    FIELDS.forEach(function (f) {
      var els = fieldEls(f.key);
      if (els.length) attrs[f.key] = (els[0].value || '').trim();
    });
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).catch(function () {});
    } catch (e) {}
  }
  function scheduleSave() { clearTimeout(saveTimer); saveTimer = setTimeout(persist, SAVE_DEBOUNCE); }

  function hideError() {
    var c = document.querySelectorAll('[data-qpost-error]');
    for (var i = 0; i < c.length; i++) { c[i].hidden = true; c[i].textContent = ''; }
  }
  function showError(msg, el) {
    var c = document.querySelectorAll('[data-qpost-error]');
    for (var i = 0; i < c.length; i++) { c[i].textContent = msg; c[i].hidden = false; }
    var all = document.querySelectorAll('[data-qpost-field]');
    for (var j = 0; j < all.length; j++) { all[j].classList.remove('qpost-invalid'); }
    if (el) {
      el.classList.add('qpost-invalid');
      try { el.focus(); } catch (e) {}
      try { el.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e2) {}
    }
  }

  // Persist + clear error state as the buyer types.
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-qpost-field]')) {
      t.classList.remove('qpost-invalid');
      hideError();
      scheduleSave();
    }
  }, true);
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-qpost-field]')) persist();
  }, true);

  // Gate the checkout button (capture phase, so we run before the theme's handlers).
  document.addEventListener('click', function (e) {
    var btn = (e.target && e.target.closest) ? e.target.closest('[name="checkout"]') : null;
    if (!btn) return;
    if (!hasFields()) return; // no fields on this page → nothing to enforce
    var r = validate();
    if (!r.valid) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showError(r.msg, r.el);
      return false;
    }
    // Valid: native form submit carries name="attributes[...]"; persist defensively too.
    persist();
  }, true);
})();
